
import React, { Component } from "react";
import LoginComp from "../../components/Login/LoginComp";

class Login extends Component {
  render() {
    return (
      <div>
        <LoginComp />
      </div>
    );
  }
}

export default Login;
